var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTagBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_3065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 32.705C23.8502 32.705 24.5394 32.0159 24.5394 31.1658C24.5394 30.3156 23.8502 29.6265 23.0001 29.6265C22.15 29.6265 21.4608 30.3156 21.4608 31.1658C21.4608 32.0159 22.15 32.705 23.0001 32.705Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 16.3738C23.8502 16.3738 24.5394 15.6846 24.5394 14.8345C24.5394 13.9843 23.8502 13.2952 23.0001 13.2952C22.15 13.2952 21.4608 13.9843 21.4608 14.8345C21.4608 15.6846 22.15 16.3738 23.0001 16.3738Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.76 1.24119C43.9606 0.440773 42.8972 0 41.7654 0H25.6395C24.5083 0 23.4447 0.440594 22.6448 1.24065L1.24083 22.6446C0.440594 23.4447 0 24.5082 0 25.6392C0 26.7703 0.440773 27.8338 1.24083 28.6333L17.3663 44.7589C18.1661 45.5592 19.2296 46 20.3608 46C21.4918 46 22.5553 45.5594 23.3554 44.7592L44.7593 23.3552C45.5594 22.5553 46 21.4917 46 20.3605V4.23461C46 3.10284 45.5592 2.03927 44.76 1.24119ZM23.0001 10.5995C25.335 10.5995 27.2347 12.4992 27.2347 14.8341C27.2347 17.1691 25.335 19.0687 23.0001 19.0687C20.6651 19.0687 18.7655 17.1691 18.7655 14.8341C18.7655 12.4992 20.6651 10.5995 23.0001 10.5995ZM23.0001 35.4003C20.6651 35.4003 18.7655 33.5007 18.7655 31.1657C18.7655 28.8308 20.6651 26.9311 23.0001 26.9311C25.335 26.9311 27.2347 28.8308 27.2347 31.1657C27.2347 33.5007 25.335 35.4003 23.0001 35.4003ZM31.6609 24.3476H14.3392C13.595 24.3476 12.9916 23.7442 12.9916 22.9999C12.9916 22.2556 13.595 21.6523 14.3392 21.6523H31.6609C32.4052 21.6523 33.0086 22.2556 33.0086 22.9999C33.0086 23.7442 32.4053 24.3476 31.6609 24.3476ZM37.4349 9.91273C36.691 9.91273 36.0873 9.30898 36.0873 8.56507C36.0873 7.82117 36.691 7.21742 37.4349 7.21742C38.1788 7.21742 38.7826 7.82117 38.7826 8.56507C38.7826 9.30898 38.1788 9.91273 37.4349 9.91273Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_3065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTagBlue);
export default __webpack_public_path__ + "static/media/icon-tag-blue.055a946ae4c333dcb46c043f9fd35dc4.svg";
export { ForwardRef as ReactComponent };